module.exports = __webpack_public_path__ + "img/vx_moments.38c3b319.png";